import { render } from "./pos-bon-livraison.vue?vue&type=template&id=5b904809&scoped=true"
import script from "./pos-bon-livraison.vue?vue&type=script&lang=js"
export * from "./pos-bon-livraison.vue?vue&type=script&lang=js"

import "./pos-bon-livraison.vue?vue&type=style&index=0&id=5b904809&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b904809"]])

export default __exports__